var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.momentsAgo)?_c('span',{directives:[{name:"line-clamp",rawName:"v-line-clamp",value:(1),expression:"1"}],staticClass:"moments_ago"},[_vm._v(" "+_vm._s(_vm.momentsAgo)+" "+_vm._s(_vm.$t('ago'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }